import Toolbar from "@material-ui/core/Toolbar";
import AppBar from "@material-ui/core/AppBar";
import LocalGasStationIcon from "@material-ui/icons/LocalGasStation";

import React, { memo } from "react";
import { useStyles } from "./header.styles";

export const Header = memo(() => {
  const classes = useStyles();

  return (
    <AppBar position="sticky">
      <Toolbar className={classes.toolbar}>
        <LocalGasStationIcon className={classes.gasolineIcon} />
        <h1 className={classes.title}>Calcul consommation</h1>
      </Toolbar>
    </AppBar>
  );
});
